"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importStar(require("styled-components"));
const styles_1 = require("@mui/material/styles");
const TextField_1 = __importDefault(require("@mui/material/TextField"));
const base_ui_theme_1 = require("@motorata/base-ui.theme");
const base_ui_components_atoms_spinner_1 = __importDefault(require("@motorata/base-ui.components.atoms.spinner"));
const base_ui_components_atoms__atoms_1 = require("@motorata/base-ui.components.atoms._atoms");
const InputAdornment_1 = __importDefault(require("@mui/material/InputAdornment"));
const react_number_format_1 = require("react-number-format");
const base_ui_components_atoms_typography_1 = require("@motorata/base-ui.components.atoms.typography");
const StyledTextField = (0, styles_1.styled)(TextField_1.default)(() => {
    return {
        "width": "100%",
        "background": "none",
        ".MuiInputLabel-root": {
            "box-sizing": "border-box",
            "background": "none",
            "color": base_ui_theme_1.baseTheme.color.second,
            "fontSize": base_ui_theme_1.baseTheme.font.M,
            "fontWeight": base_ui_theme_1.baseTheme.font.normal,
            "transform": "translate(20px,19px) scale(1)",
            "&.MuiInputLabel-shrink": {
                transform: "translate(20px, 11px) scale(1)",
                color: base_ui_theme_1.baseTheme.color.second,
                fontSize: base_ui_theme_1.baseTheme.font.S,
            },
        },
        ".MuiFilledInput-root": {
            "box-sizing": "border-box",
            "background": "none",
            "padding-left": "20px",
            "padding-top": "27px",
            "padding-bottom": "9px",
            "lineHeight": base_ui_theme_1.baseTheme.font.L,
            "&:before, &:after": {
                display: "none",
            },
            "input, textarea": {
                "box-sizing": "border-box",
                "color": base_ui_theme_1.baseTheme.color.second,
                "fontSize": base_ui_theme_1.baseTheme.font.L,
                "lineHeight": base_ui_theme_1.baseTheme.font.L,
                "fontWeight": base_ui_theme_1.baseTheme.font.light,
                "padding": "0",
                "padding-right": "10px",
            },
            "input": {
                height: 23,
            },
        },
        ".MuiInputAdornment-root": {
            margin: "0 !important",
            fontSize: base_ui_theme_1.baseTheme.font.L,
            lineHeight: base_ui_theme_1.baseTheme.font.L,
            fontWeight: base_ui_theme_1.baseTheme.font.light,
            height: 23,
        },
    };
});
const PatterFormatCustom = react_1.default.forwardRef(function PatterFormatCustom(props) {
    const { onChange = () => { }, name, value, format, formattedValue } = props, other = __rest(props, ["onChange", "name", "value", "format", "formattedValue"]);
    return (react_1.default.createElement(react_number_format_1.PatternFormat, Object.assign({}, other, { value: value || "", onValueChange: values => {
            onChange({
                // @ts-ignore
                target: {
                    name: name,
                    value: formattedValue ? values.formattedValue : values.value,
                },
            });
        }, format: format })));
});
const NumericFormatCustom = react_1.default.forwardRef(function NumericFormatCustom(props) {
    const { name, value, onChange = () => { } } = props, other = __rest(props, ["name", "value", "onChange"]);
    return (react_1.default.createElement(react_number_format_1.NumericFormat, Object.assign({}, other, { value: value || "", onValueChange: values => {
            var _a;
            onChange({
                target: {
                    name: name,
                    // @ts-ignore
                    value: (_a = values === null || values === void 0 ? void 0 : values.floatValue) !== null && _a !== void 0 ? _a : 0,
                },
            });
        } })));
});
const Input = (_a) => {
    var { elementType = "text", type, label, defaultValue, value, name, background = "background", width = "100%", error, loading, disabled, startAdornment, endAdornment, format = "+48 ### ### ###", formattedValue = false, decimalScale = 2, decimalSeparator = ",", allowNegative = false, 
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    onChange = () => { }, rhf = {}, multiline, rows, maxRows } = _a, rest = __rest(_a, ["elementType", "type", "label", "defaultValue", "value", "name", "background", "width", "error", "loading", "disabled", "startAdornment", "endAdornment", "format", "formattedValue", "decimalScale", "decimalSeparator", "allowNegative", "onChange", "rhf", "multiline", "rows", "maxRows"]);
    const { ref } = rhf, rhfRest = __rest(rhf, ["ref"]);
    const handleOnChange = (event) => {
        onChange({
            name,
            value: event.target.value,
        });
    };
    return (react_1.default.createElement(base_ui_components_atoms__atoms_1.Box, Object.assign({ width: width }, rest),
        react_1.default.createElement(StyledBox, { width: width, hasLabel: !!label, background: background, disabled: disabled },
            react_1.default.createElement(StyledTextField, Object.assign({ inputRef: ref, onChange: handleOnChange, label: label, error: !!error, disabled: disabled, variant: "filled", defaultValue: defaultValue, type: type, InputProps: {
                    inputComponent: elementType === "numeric"
                        ? NumericFormatCustom
                        : elementType === "pattern"
                            ? PatterFormatCustom
                            : undefined,
                    inputProps: {
                        decimalScale,
                        decimalSeparator,
                        allowNegative,
                        format,
                        formattedValue,
                        value,
                    },
                    startAdornment: startAdornment && (react_1.default.createElement(InputAdornment_1.default, { position: "start" }, startAdornment)),
                    endAdornment: !loading && endAdornment && (react_1.default.createElement(InputAdornment_1.default, { position: "end" }, endAdornment)),
                }, multiline: multiline, rows: rows, maxRows: maxRows }, rhfRest)),
            loading && (react_1.default.createElement(SpinnerWrapper, null,
                react_1.default.createElement(base_ui_components_atoms_spinner_1.default, { size: "15px", borderWidth: 3 })))),
        error && (react_1.default.createElement(ErrorFormHelperText, null, (error === null || error === void 0 ? void 0 : error.type) === "required" ? "To pole jest wymagane" : error === null || error === void 0 ? void 0 : error.message))));
};
exports.default = Input;
const ErrorFormHelperText = (0, styled_components_1.default)(base_ui_components_atoms_typography_1.P) `
    color: ${({ theme }) => theme.color.red} !important;
    font-size: ${({ theme }) => theme.font.S};
    margin: 3px 10px;
`;
const SpinnerWrapper = styled_components_1.default.div `
    position: absolute;
    right: 15px;
    top: 21px;
`;
const StyledBox = (0, styled_components_1.default)(base_ui_components_atoms__atoms_1.Box) `
  ${base_ui_components_atoms__atoms_1.common};
  min-width: ${({ width }) => width};
  position: relative;
  border-radius: 3px;
  overflow: hidden;
    
  * {
    box-sizing: border-box;
    font-family: 'Poppins' !important;
  }
  
  .MuiFilledInput-root{
    border-radius: 3px;
    overflow: hidden;
    background: ${({ theme, background = "background" }) => { var _a; return (_a = theme.color[background]) !== null && _a !== void 0 ? _a : background; }} !important;
      
      input {
        text-align: ${({ textAlign }) => textAlign};
      }
  };
  
   &.Mui-error {
      color: #f8563f !important;
    };
    
    ${({ hasLabel }) => !hasLabel &&
    (0, styled_components_1.css) `
        .MuiFilledInput-root {
          padding-top: 9px !important;
        }
      `};
      
      ${({ disabled }) => disabled && (0, styled_components_1.css) `
        cursor: not-allowed;
  
        * {
          cursor: not-allowed;
        }
      `}
  `;
//# sourceMappingURL=Input.js.map